<template>
  <mdb-container class="gp-has-header">
    <div v-show="view=='list'">
      <data-table :add-handler="newDeck"
                  :clickHandler="prepareEdit"
                  :columns="columns"
                  add-label="New Deck"
                  dataSource="/campfireAdmin/gameDeckList"
                  pageTitle="Game Decks"
                  show-add-button
                  table-id="game-deck"/>
    </div>

    <div v-if="view=='edit'" class="text-left">
      <mdb-btn icon="arrow-left" @click="goBack">Back to List</mdb-btn>
      <mdb-card>
        <mdb-card-header class="primary-color text-white">
          <h3>{{ workingDeck.title }}</h3>
        </mdb-card-header>
        <mdb-card-body>
          <div>
            <gp-select :dataObj="workingDeck" :possible-values="gameTypes" :required="true"
                       label="Game" propertyName="gameId"/>
            <mdb-input v-model="workingDeck.title" label="Title" placeholder="Title"/>
            <div v-if="selectedGame.needsLetterSet">
              <label class="formless-label">{{selectedGame.letterSetLabel}}</label>
              <cust-chip-input :chips="workingDeck.letterSet"/>
            </div>
            <div class="grey lighten-5 border">
              <label class="formless-label">Deck 1</label>
              <div>{{ workingDeck.deck1 }}</div>
              <mdb-btn icon="spade" rounded size="sm" @click="prepareNavigator(1)">
                {{ workingDeck.deck1 ? 'Change Deck 1' : 'Select Deck 1' }}
              </mdb-btn>
              <mdb-btn v-if="workingDeck.deck1" icon="trash" color="warning" rounded size="sm" @click="removeDeck(1)">Remove Deck</mdb-btn>
            </div>
            <div class="grey lighten-5 border">
              <label class="formless-label">Deck 2</label>
              <div>{{ workingDeck.deck2 }}</div>
              <mdb-btn icon="spade" rounded size="sm" @click="prepareNavigator(2)">
                {{ workingDeck.deck2 ? 'Change Deck 2' : 'Select Deck 2' }}
              </mdb-btn>
              <mdb-btn v-if="workingDeck.deck2" icon="trash" color="warning" rounded size="sm" @click="removeDeck(2)">Remove Deck</mdb-btn>
            </div>
          </div>

          <mdb-input v-model="workingDeck.description" :rows="5" label="Description" placeholder="Description"
                     type="textarea"/>
        </mdb-card-body>
        <mdb-card-footer>

          <mdb-btn :disabled="!workingDeck.title" color="success" icon="save" @click="saveDeck">Save</mdb-btn>
          <mdb-btn icon="minus-circle" @click="cancelEdit">Cancel</mdb-btn>
          <mdb-btn icon="trash" color="danger" @click="deleteModal=true">Delete</mdb-btn>
        </mdb-card-footer>
      </mdb-card>

      <yes-no-modal v-if="deleteModal"
                    @no="deleteModal=false"
                    @yes="deleteCard"/>

      <mdb-modal v-if="cardSetNavigator" size="lg" @close="cardSetNavigator = false">
        <mdb-modal-header :close="true" class="primary-color text-white">Select a Card Set
        </mdb-modal-header>
        <mdb-modal-body>
          <data-table :clickHandler="pickedSet"
                      :columns="setColumns"
                      dataSource="/campfireAdmin/cardSetList"/>
        </mdb-modal-body>
      </mdb-modal>

    </div>

  </mdb-container>
</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';

import DataTable from "../common/DataTable";
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";
import gpSelect from "../common/GPSelect";
import {custChipInput} from "../common/CustChipInput";


export default {
  name: 'game-deck',
  components: {
    mdbContainer, mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbIcon,
    mdbRow,
    mdbCol,
    DataTable,
    YesNoModal,
    gpSelect,
    custChipInput
  },
  data() {
    return {
      columns: [
        {label: "ID", field: "id"},
        {label: "Game", field: "game"},
        {label: "Deck Title", field: "title"},
        {label: "Deck 1 Card Set", field: "deck1"},
        {label: "Deck 2 Card Set", field: "deck2"}
      ],
      setColumns: [
        {label: "ID", field: "id"},
        {label: "Title", field: "title"}
      ],
      editingDeck: null,
      workingDeck: null,
      view: "list",
      editDetails: false,
      needsRefresh: false,
      deleteModal: false,
      gameTypes: [],
      cardSetNavigator: false,
      deckSelecting: null
    }
  },
  computed: {
    selectedGame()  {
      let ret = {needsLetterSet: false, letterSetLabel: null}
      for (let g of this.gameTypes) {
        if (this.workingDeck.gameId == g.value) {
          ret = g
        }
      }
      return ret
    }
  },
  mounted() {
    this.loadAllTypes()
  },
  methods: {
    removeDeck(i) {
      if (i == 1) {
        this.workingDeck.deck1 = ""
        this.workingDeck.deck1Id = null
      }
      else {
        this.workingDeck.deck2 = ""
        this.workingDeck.deck2Id = null
      }
    },
    prepareNavigator(i) {
      this.deckSelecting = i
      this.cardSetNavigator = true
    },
    pickedSet(set) {
      if (this.deckSelecting == 1) {
        this.workingDeck.deck1 = set.title
        this.workingDeck.deck1Id = set.id
      } else {
        this.workingDeck.deck2 = set.title
        this.workingDeck.deck2Id = set.id
      }
      this.cardSetNavigator = false
    },
    openDeck(deck) {
      this.editingDeck = deck
      this.view = "edit"
    },
    prepareEdit(deck) {
      this.workingDeck = JSON.parse(JSON.stringify(deck))
      this.view = "edit"
    },
    newDeck() {
      this.workingDeck = {id: null, title: "", description: "", game: null,
        gameId: null, deck1: "", deck1Id: null, deck2: "", deck2Id: null,
              letterSet: ["a","b","c","d","e","f","g","h","i","j", "k", "l",
                          "m","n","o","p","q","r","s","t","u","v","w","x","y","z"]}
      this.view = "edit"
      this.editDetails = true
    },
    goBack() {
      this.view = "list"
      if (this.needsRefresh) this.$store.dispatch("setDataTableReload", true)
      this.workingDeck = null
      this.editDetails = false
    },
    cancelEdit() {
      this.view = "list"
      this.workingDeck = null
    },
    saveDeck() {
      this.deckModal = false
      this.$store.dispatch("setExecuting", true);
      api.post("/campfireAdmin/gameDeck/", this.workingDeck).then(
        (results) => {
          let payload = {tableId: "game-deck", data: results.data}
          if (this.workingDeck.id) {
            this.$store.dispatch("updateTableRow", payload)
          }
          else {
            this.workingDeck = results.data
            this.$store.dispatch("insertTableRow", payload)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.setModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteCard() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/campfireAdmin/gameDeck/" + this.workingDeck.id).then(
        (results) => {
          this.needsRefresh = true
          this.goBack()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadAllTypes() {
      this.$store.dispatch("setExecuting", true)
      api.get("/campfire/types/").then(
        (results) => {
          this.gameTypes = []
          for (let d of results.data) {
            this.gameTypes.push({value: d.id, text: d.name, needsLetterSet: d.needsLetterSet, letterSetLabel: d.letterSetLabel});
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

};
</script>
